import styled from 'styled-components'

// import { MusicContainer } from './MusicPlayer'

import BlackButton from '@silvermine/videojs-chromecast/dist/images/ic_cast_black_24dp.png'

const Overlay = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  transition: all 0.3s ease-in;
  background: linear-gradient(
    122.87deg,
    rgba(255, 255, 255, 0.8) 22%,
    rgba(255, 255, 255, 0.2) 50.03%
  );
  visibility: visible;
  z-index: 1; /* Overlay video poster */
`

const TitleContainer = styled('div')`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 24px;
  left: 24px;
  transition: all 0.3s ease-in;
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
  z-index: 1; /* Overlay poster */
`

/*
 * VideoPlayerContainer is the wrapper for all of videoJS.
 * This also includes the transition handlers for title card, and overlay information.
 * MusicCard transitions are in _musicPlayerStyles.js, which imports VideoPlayerContainer.
 */
const VideoPlayerContainer = styled('div')`
  --video-player-animation-default: all 0.3s ease-in-out;

  overflow: hidden;

  .video-js {
    cursor: pointer;
    color: ${(props) => props.theme.colors.primary};
    font-family: ${(props) => props.theme.fonts.Proxima};
    font-size: 14px;
    height: auto;
    width: auto;

    &.vjs-has-started .vjs-control-bar {
      transition: var(--video-player-animation-default);
    }

    &.vjs-has-started.vjs-user-inactive.vjs-playing {
      ${Overlay} {
        transition: var(--video-player-animation-default);
        opacity: 0;
        visibility: hidden;
      }

      ${TitleContainer} {
        transition: var(--video-player-animation-default);
        transform: translateY(-100%);
        opacity: 0;
        visibility: hidden;
        background: transparent;
      }

      .vjs-control-bar {
        transform: translateY(100%);
        transition: visibility 0.3s, opacity 0.3s, transform 0.3s ease-in-out;
      }
    }

    #close-settings-menu {
      /* We need to override vjs button colors here*/
      background-color: ${(props) => props.theme.colors.grey1};

      :hover {
        background-color: ${(props) => props.theme.colors.grey2};
      }
    }

    .vjs-play-progress {
      /* Completed section of progress bar */
      background-color: ${(props) => props.theme.colors.primary};
    }

    .vjs-progress-control {
      /* allow for center align of progress knob */
      .vjs-slider-bar {
        display: flex;
      }

      /* increase size of progress knob and center it */
      .vjs-slider-bar:before {
        font-size: 20px;
        align-self: center;
        top: auto;
      }

      /* Make progress bar smaller until height change */
      .vjs-slider-horizontal {
        height: 2px;
        transition: height 0.1s ease-in-out;
      }
    }

    .vjs-progress-control:hover {
      /* Don't change progress knob on hover */
      .vjs-slider-bar:before {
        font-size: 20px;
      }

      /* Increase progress bar height on hover */
      .vjs-slider-horizontal {
        height: 4px;
      }
    }

    .vjs-load-progress {
      background: ${(props) => props.theme.colors.grey6};
    }

    .vjs-slider {
      /* Uncompleted section of progress-bar */
      background-color: ${(props) => props.theme.colors.grey2};
    }

    .vjs-control-bar {
      z-index: 2; /* Place over Overlay */
      display: flex;
      height: 48px;
      padding: 0px 12px;
      background-color: ${(props) => props.theme.colors.base};
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06),
        0px 8px 16px rgba(35, 41, 54, 0.08);
      opacity: ${(props) => (props.showSettings ? '0' : '1')};
      visibility: ${(props) => (props.showSettings ? 'hidden' : 'visible')};

      transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

      .vjs-play-control span:before {
        font-size: 2em;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: unset;
      }

      .vjs-button {
        width: 40px !important; /* booo, must use !important to override CSS order (.vjs-control)*/
      }

      .vjs-icon-placeholder:before {
        line-height: 1.8em; /* magic numbers, yay! This is the same font-size as the play and full-screen icons */
      }

      .vjs-time-control {
        display: none;
        padding: 0;
        min-width: 40px;
        ${(props) => props.theme.mediaQueries.small} {
          /* display and center-align our current and remaining time divs above small breakpoint*/
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .vjs-chromecast-button .vjs-icon-placeholder {
        background: url(${BlackButton}) center center no-repeat;
        background-size: contain;
        width: 20px;
        height: 20px;
        margin: 0;
      }
    }
  }
`

export {
  // MusicContainer,
  Overlay,
  TitleContainer,
  VideoPlayerContainer
}
